import { z } from 'zod';
import { socialVideoFormatSchema } from '../../social/social-video-format-schema';

export const socialClipSchema = z.object({
  clipId: z.number(),
  localPath: z.string(),
  durationMs: z.number(),
  subtitleText: z.string(),
  targetPhrase: z.string(),
  collectionName: z.string(),
});

export const socialWordTimingSchema = z.object({
  word: z.string(),
  startMs: z.number(),
  endMs: z.number(),
});

export const generateSocialVideoRequestSchema = z.object({
  socialVideoId: z.number(),
  challengeId: z.number(),
  slug: z.string(),
  version: z.number(),
  format: socialVideoFormatSchema.optional().default('vertical'),
  phrase: z.string(),
  definition: z.string().optional(),
  usage: z.string().optional(),
  audioUrl: z.string(),
  audioWordTimings: z.array(socialWordTimingSchema),
  clips: z.array(socialClipSchema).min(1),
});

export type ISocialClip = z.infer<typeof socialClipSchema>;
export type ISocialWordTiming = z.infer<typeof socialWordTimingSchema>;
export type IGenerateSocialVideoRequest = z.infer<typeof generateSocialVideoRequestSchema>;
